module.exports = __webpack_public_path__ + "img/img-testimonial-logo-2.cfa2447.png";